<template>
   <svg name="tick-circle" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
      <path
         fill-rule="evenodd"
         clip-rule="evenodd"
         d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.2437 5.86872C10.5854 5.52701 10.5854 4.97299 10.2437 4.63128C9.90201 4.28957 9.34799 4.28957 9.00628 4.63128L6.125 7.51256L4.99372 6.38128C4.65201 6.03957 4.09799 6.03957 3.75628 6.38128C3.41457 6.72299 3.41457 7.27701 3.75628 7.61872L5.50628 9.36872C5.84799 9.71043 6.40201 9.71043 6.74372 9.36872L10.2437 5.86872Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
